import React from "react";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";
import Typography from "@mui/joy/Typography";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

type BreadcrumbLink = {
   label: string;
   href?: string;
};

type PageBreadcrumbsProps = {
   links: BreadcrumbLink[];      // Intermediate links
   current: string;              // Final breadcrumb label
   heading?: string;             // Optional H2 title below breadcrumbs
   icon?: React.ReactNode;       // Optional home icon
   homeHref?: string;            // Optional override for home link
};

const PageBreadcrumbs: React.FC<PageBreadcrumbsProps> = ({
   links,
   current,
   heading,
   icon = <HomeRoundedIcon />,  // Default icon
   homeHref = "#",
}) => {
   return (
      <Breadcrumbs
         size="sm"
         aria-label="breadcrumbs"
         separator={<ChevronRightRoundedIcon fontSize="small" />}
         sx={{ pl: 0 }}
      >
         <Link underline="none" color="neutral" href={homeHref} aria-label="Home">
            {icon}
         </Link>

         {links.map((link, idx) => (
            <Link
               key={idx}
               underline="hover"
               color="neutral"
               href={link.href}
               sx={{ fontSize: 12, fontWeight: 500 }}
            >
               {link.label}
            </Link>
         ))}

         <Typography color="primary" sx={{ fontWeight: 500, fontSize: 12 }}>
            {current}
         </Typography>
      </Breadcrumbs>
   );
};

export default PageBreadcrumbs;